<template>
  <div
    class="lead-full-name d-inline-flex align-items-center"
  >
    <router-link
      v-if="withLink"
      :to="{ name: 'app.leads.profile', params: { id: lead.id } }"
    >
      {{ lead.full_name }}
    </router-link>
    <span v-else>
      {{ lead.full_name }}
    </span>
    <i
      v-if="withIcon && lead.is_blocked"
      class="ml-1 text-red q-icon fa fa-ban"
    />
  </div>
</template>

<script>
export default {
  name: 'SdLeadFullName',
  props: {
    lead: {
      type: Object,
      required: true,
    },
    withLink: {
      type: Boolean,
      default: true,
    },
    withIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
